module.exports = __webpack_public_path__ + "img/belt.13fa1063.png";